var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',{staticClass:"agreement",on:{"closePanel":function($event){return _vm.$emit('closePanel')}}},[_c('h1',[_vm._v("知灾害风险管理平台用户隐私政策")]),_c('div',{staticClass:"agreement-body",domProps:{"innerHTML":_vm._s(_vm.yinsi)}})])}
var staticRenderFns = []

export { render, staticRenderFns }